var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ColorPick',{attrs:{"value":_vm.value,"placeholder":_vm.placeholderValue},on:{"input":function($event){return _vm.updateProp($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }